import { FC } from 'react';
import { Badge, SpaceBetween, Icon } from '@amzn/awsui-components-react';
import { TOOL_STATUS, ToolStatus } from '../../constants';

interface StatusBadgeProps {
  status: ToolStatus | 'NO_ASSIGNMENT' | 'PENDING_REVISION';
  text?: string;
}

const StatusBadge: FC<StatusBadgeProps> = ({ status, text }) => {
  const getStatusConfig = () => {
    switch (status) {
      case TOOL_STATUS.VALID:
        return {
          color: 'green' as const,
          icon: 'status-positive' as const,
          displayText: text || TOOL_STATUS.VALID
        };
      case TOOL_STATUS.INVALID:
        return {
          color: 'red' as const,
          icon: 'status-negative' as const,
          displayText: text || TOOL_STATUS.INVALID
        };
      case 'NO_ASSIGNMENT':
        return {
          color: 'grey' as const,
          icon: null,
          displayText: text || 'No Assignment'
        };
      case 'PENDING_REVISION':
        return {
          color: 'blue' as const,
          icon: null,
          displayText: text || 'Pending Revision'
        };
      default:
        return {
          color: 'green' as const,
          icon: 'status-positive' as const,
          displayText: text || TOOL_STATUS.VALID
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Badge color={config.color}>
      {config.icon ? (
        <SpaceBetween direction="horizontal" size="xs">
          <Icon key="icon" name={config.icon} />
          <span key="text">{config.displayText}</span>
        </SpaceBetween>
      ) : (
        config.displayText
      )}
    </Badge>
  );
};

export default StatusBadge;
